import { render, staticRenderFns } from "./wechatAuth.vue?vue&type=template&id=99880c94"
import script from "./wechatAuth.vue?vue&type=script&lang=js"
export * from "./wechatAuth.vue?vue&type=script&lang=js"
import style0 from "./wechatAuth.vue?vue&type=style&index=0&id=99880c94&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports